export const lingua_fr = {
  lang: "fr",
  title: "3D SHIRT - Configurateur 3d de chemises personnalisé",
  description: "Configurateur 3d de chemises personnalisé",
  personalizza: "Personnaliser",
  misure: "Mesures",
  tessuto: "Tissu",
  filtri: "Filtres",
  scegliTessuto: "Choisir tissu",
  cercaTessuto: "Chercher du tissu...",
  inOfferta: "Offre Promotionnelle",
  nonDisponibile: "Non disponible",
  colore: "Couleur",
  colori: "Couleurs",
  tuttiColori: "Toutes les couleurs",
  bianco: "Blanc",
  celeste: "Bleu clair",
  altriColori: "Autres couleurs",
  disegno: "Tissus",
  disegni: "Tissus",
  tuttiDisegni: "Toutes les tissus",
  tintaUnita: "Tissus de couleur unie",
  righe: "Tissus à rayures",
  quadretti: "Tissus à carreaux",
  fantasia: "Tissus à motifs imprimés",
  materiale: "Matière",
  materiali: "Matière",
  tuttiMateriali: "Toutes les matière",
  cotone: "Coton",
  lino: "Lin",
  brand: "Marque",
  brands: "Marques",
  tuttiBrands: "Toutes les Marques",
  codice: "Code",
  ordina: "Trier par prix",
  basso: "Par ordre croissant",
  alto: "Par ordre dècroissant",
  lato: "Vista laterale",
  front: "Vista frontale",
  retro: "Vista retro",
  piegata: "Vista piegata",
  extra: {
    tutti: "Tous les produits",
    selTaglia: "Choisissez la taille",
    desc: "Description",
    correlati: "Produits connexes",
  },
  bubble: {
    prima: "Clicca qui per tornare alla vista camicia.",
    seconda: "Trascina con il tasto SINISTRO del mouse per ruotare la camicia",
    terza: "Trascina con il tasto DESTRO del mouse per spostare la camicia.",
    quarta: "Muovi la ROTELLINA del mouse per lo zoom.",
    quinta: "OK, CHIUDI",
    sesta: "Trascina con un dito per ruotare la camicia.",
    settima: "Trascina con due dita per spostare la camicia.",
    ottava: "Allarga o stringi con due dita per lo zoom.",
  },
  banner: {
    titolo: "Utilisation de cookies",
    testo1:
      "Dans cette Application, nous utilisons des cookies (ou technologies similaires) pour stocker des informations sur votre ordinateur ou votre appareil mobile afin d'améliorer votre expérience en ligne. Les cookies sont de petits fichiers texte qui vous permettent de naviguer efficacement, de mémoriser vos préférences, de nous aider à comprendre les performances de l'Application et d'améliorer généralement votre expérience d'utilisateur.",
    testo2:
      "En fermant ce message, ou en naviguant sur le site, vous acceptez l'utilisation de cookies en fonction de vos préférences.",
    gestione: "Gestion des cookies",
    acconsento: "Je suis d'accord",
  },
  sito: {
    titolo: "La tua camicia su misura direttamente dal produttore!",
    sottotitolo:
      "La nostra è un’azienda ad impronta artigianale e negli anni ha condiviso la passione per questo lavoro con un valido gruppo di esperte lavoratrici che con grande spirito di sacrificio ha saputo mantenere i legami con le proprie radici culturali dalla forte tradizione sartoriale.",
    bottone1: "Inizia a creare la tua camicia!",
    titolo2: "Un configuratore 3D senza limiti",
    sottotitolo2:
      "La camiceria Su Misura di Lodi produce e vende per aziende e privati",
    configura: "Configura",
    titolo3: "CAPI DI VERA MODA ARTIGIANALE ITALIANA!",
    sottotitolo3:
      "Offriamo tutta la nostra esperienza per confezionare camicie di qualità interamente fatte a mano secondo la tradizione sartoriale italiana.",
    titolo4: "Qualità delle immagini",
    sottotitolo4:
      "Scegli una camicia su misura, ti garantiamo una",
    titolo5: "VESTIBILITA' PERFETTA",
    sottotitolo5:
      "ed un elevato confort perchè si tratta di un capo tagliato sulla persona in base alla corporatura e alle esigenze specifiche del cliente.",
    sottotitolo6:
      "Per la nostra produzione impieghiamo",
    titolo7: "MATERIE PRIME ECCELLENTI",
    sottotitolo7:
      "100% Cotone doppio ritorto prodotto dalle migliori aziende italiane quali: Albini, Canclini, Canaloni, Monti, Ibieffe, Fratelli Tosetti, Reda e Rubinelli.",
    titolo8: "Senza limiti...",
    sottotitolo8:
      "Bottoni di ottima madreperla, Pvc riciclato e Corozo cuciti sapientemente con cotoni e sete di filati Guttermann e Maidera.",
    titolo9: " Web Marketing",
    sottotitolo9:
      "Continua evoluzione di materiali ecosostenibili.",
    titolo10: "Caratteristiche del configuratore 3D SHIRT",
    sottotitolo10:
      "Tutta la versatilità di una camicia... perfetta in ogni occasione!",
    titolo11: "AMPIA SCELTA",
    sottotitolo11:
      "Privilegia il look che più ti rappresenta! Potrai scegliere il tuo stile tra il vasto assortimento di tessuti e le diverse tipologie di finiture.",
    titolo12: "I NOSTRI SERVIZI",
    serv1tit:"CONTATTO",
    serv2tit:"PRESA IN CARICO ORDINE",
    serv3tit:"CONFEZIONAMENTO",
    serv1des:"Seguiamo il cliente passo dopo passo, dalla presa delle misure alla scelta delle finiture, per realizzare il prodotto che più soddisfi le esigenze richieste.",
    serv2des:"Una modellista esperta prepara e sviluppa il cartamodello della camicia da cui parte il processo di produzione, svolto interamente a mano in ogni passaggio.",
    serv3des:"Una artigiana professionista si occupa della realizzazione del capo avendo cura di ogni singolo dettaglio come le cuciture realizzate a mano.",
    sottotitolo12:
      "L'applicazione è in grado di gestire tutte le fasi del processo d'acquisto, dalla gestione del carrello, e quindi prodotti e codici sconto, fino alla gestione della spedizione e del pagamento.",
    titolo13: "Creazione Account",
    sottotitolo13:
      "L'applicazione prevede la possibilità di creare un profilo utente personale che permetterà all'utente stesso di memorizzare le proprie misure e i propri acquisti.",
    newshop:
      "Da oggi 3D SHIRT permette la vendita di prodotti collegati alla tua sartoria! Non solo camicie personalizzate ma anche camicie pronte, cravatte o quello che vuoi!",
  },
  contact: {
    titolo: "Envoyez nous un message",
    sottotitolo:
      "Contactez-nous pour demander un devis ou simplement pour des questions ou suggestions. Nous vous répondrons dans les plus brefs délais.",
    nome: "Votre nom",
    telefono: "Votre téléphone",
    email: "Votre email",
    messaggio: "Laisser un message",
    invia: "Envoyez le message",
  },
  header: {
    account: "Account",
    modificapassword: "Changez votre mot de Passe",
    logout: "Logout",
    wishlist: "Liste de Voeux",
    shopping: "Panier d'Achat",
    loggedOut: "Vous n'êtes plus connecté.",
    loggedOutError: "Une erreur est survenue:",
    cambiaPasswordSuccess:
      "Nous vous enverrons un email contenant un lien unique pour réinitialiser votre mot de passe.",
    cambiaPasswordError: "L'erreur suivante s'est produite:",
  },
  coloriTip: {
    grigio: "Gris",
    blu: "Bleu",
    nero: "Noir",
    marrone: "Marron",
    verde: "Vert",
    bianco: "Blanc",
    viola: "Pourpre",
    arancione: "Orange",
    beige: "Beige",
    giallo: "Jaune",
    rosa: "Rose",
    rosso: "Rouge",
  },
  footer: {
    account: "Account",
    login: "Login",
    logout: "Logout",
    cookie: "Cookie Policy",
    privacy: "Privacy Policy",
    termini: "Termes et Conditions",
    recesso: "Droit de Retrait",
    contattaci: "Contactez Nous",
    partita: "P.IVA",
  },
  dettaglio: {
    descrizione: "Description du tissu",
    comeMisure: "Comment prendre vos mesures",
    spedizione: "Expédition et retour",
  },
  navigazione: {
    lang: "fr",
    tessuto: "Tissu",
    scegliTessuto: "Choisir tissu",
    inOfferta: "Offre Promotionnelle",
    nonDisponibile: "Non disponible",
    personalizza: "Personnaliser",
    personalizzazione: "Personnalisation",
    polsinoGemelli: "Poignet manchette",
    contrastoColletto: "Appliquer au cou",
    contrastoPolsino: "Appliquer au poignet",
    contrastoChiusura: "Appliquer à la fermeture",
    chiusura: "Fermeture",
    colletto: "Cou",
    polsino: "Poignet",
    taschino: "Poches",
    pinces: "Pinces",
    asole: "Boutonnière",
    bottoni: "Boutons",
    fili: "Fil",
    contrasto: "Contraste",
    loading: "Chargement...",
    mascherina: "Masque",
    maniche: "Manches",
    durezzaTitolo: "Rigiditè du col",
    durezza1: "Rigide",
    durezza2: "Ordinaire",
    durezza3: "Doux",
    durezza4: "Super Doux",
    velaTitolo: "Repli",
    vela1: "Repli 7",
    vela2: "Repli 7.5",
    vela3: "Repli 8",
    vela4: "Repli 8.5",
    vela5: "Repli 9",
    vela6: "Cou espacé",
    fondo: {
      titolo: "Fondo Camicia",
      classico: "Classico",
      dritto: "Dritto",
      drittoSpacchi: "Dritto con spacchi",
    },
    iniziali: {
      iniziali: "Initiales",
      inserisciIniziali: "Entrez vos initiales",
      tueIniziali: "Entrez vos initiales",
      stile: "Style des initiales",
      colore: "Couleur des initiales",
      bianco: "Blanc",
      blu: "Bleu",
      celeste: "Bleu clair",
      grigio: "Gris",
      nero: "Noir",
      rosso: "Rouge",
      verde: "Vert",
      arancione: "Orange",
      rosa: "Rose",
      posizione: "Choisir la position",
      sopra: "Haut",
      centro: "Centre",
      sotto: "Bas",
      polsinoSx: "Manchette gauche",
      polsinoDx: "Manchette droite",
      stile1: "style",
      colore1: "color",
      posizione1: "position",
    },
    misure: {
      misuraNeutra: "Chemise de test",
      misuraNeutraTitolo: "Voulez-vous essayer la chemise avant de l'acheter?",
      misuraNeutraTesto1:
        "Commandez une chemise neutre dans les tailles sélectionnées, au prix de seulement 20,00 €.",
      misuraNeutraTesto2:
        "Le coût de la chemise de test sera réduit plus tard lors de la commande finale.",
      metodoTitolo: "Sélectionnez votre méthode",
      metodoTaglia: "Mesures à partir de tailles standard",
      metodoCorpo: "Mesurez votre corps",
      metodoCamicia: "Mesurez une chemise qui vous convient",
      metodoInvia: "Envoyez-nous une chemise pour la mesurer",
      metodoModifica: "Editer",
      metodoInformazioni: "Information",
      selezionaTaglia: "Choisissez votre taille...",
      selezionaVestibilita: "Choisissez votre coupe...",
      selezionaCorporatura: "Sélectionnez votre construction...",
      selezionaSpalle: "Sélectionner la descente des épaules...",
      corporatura: {
        pancia: {
          nome: "Pancia",
          piatta: "Plat",
          regolare: "Régulière",
          sporgente: "Bombé",
        },
        spalle: {
          nome: "Spalle",
          alte: "Hautes",
          regolari: "Régulières",
          basse: "Basses",
        },
      },

      taglie: "TAILLES",
      Vita: "Taille",
      lunghezzaCam: "Longueur",

      misure: "Mesures",
      tueMisure: "Vos mesures",
      salva: "Enregistrez vos mesures",
      errore: "Une erreur est survenue",
      successo: "Les mesures ont été enregistrées avec succès",
      Braccia: "Manches",
      Bicipite: "Bíceps",
      Avambraccio: "Avambraccio",
      PuntoVitaDietro: "Punto vita dietro",
      LunghezzaDavanti: "Lunghezza Davanti",
      MezzoTorace: "Mezzo Torace",
      PuntoTorace: "Punto Torace",
      MezzaManica: "Mezza Manica",
      Collo: "Cou",
      Girovita: "Taille",
      Polso: "Poignet",
      Spalle: "Epaules",
      Torace: "Poitrine",
      Lunghezza: "Longueur",
      ColloSpalla: "Collo Spalla",
      PettoGiro: "Petto Giro",
      PettoSpalla: "Petto Spalla",
      fianco: "Fianco",
      giroManica: "Giro Manica",
      dimColloSpalla: "Taille Cou - Epaules",
      PettoGiro: "Poitirne - Taille Ronde",
      ColloSpalla: "Cou - Epaules",
      fianco: "Mesure de coté",
      giroManica: "Emmanchure",
      vuoiAiuto: "Vous voulez de l'aide avec les mesures?",
      provaSelezionare: "Choisissez votre taille",
      successoCarica: "Les mesures ont été chargées avec succès",
      seleziona: "Sélectionner...",
      xs: "XS - 36",
      s: "S - 37/38",
      m: "M - 39/40",
      l: "L - 41/42",
      xl: "XL - 43/44",
      xxl: "XXL - 45/46",
      xxxl: "XXXL - 47/48",
      oppure: "ou",
      stoCaricando: "Chargement...",
      carica: "Chargez vos mesures",
      inviaTitolo: "Envoyez-nous la chemise à mesurer",
      inviaParag1:
        "Voulez-vous reproduire les mesures d'une chemise en votre possession, mais vous ne savez pas comment la mesurer correctement?",
      inviaParag2:
        "Envoyez-nous votre chemise et nos experts la mesureront et garderont vos mensurations pour les futurs achats. * Notez qu'aucun dommage sera causé à votre chemise et vous sera renvoyé de la meilleure façon possible.",
      inviaParag3: "Envoyer à:",
      inviaTitolo2: "Lors de la soumission, assurez-vous d'inclure:",
      inviaLista1: "La chemise que vous souhaitez que nous mesurions",
      inviaLista2: "Votre nom",
      inviaLista3: "Un numéro de téléphone",
      inviaLista4: "Votre adresse e-mail",
      inviaLista5: "L'adresse de livraison",
      inviaLista6: "Toutes instructions spéciales",
      infoTipoMisure: "Type de mesures:",
      infoTipoMisure0: "mesures par taille",
      infoTipoMisure1: "mesures du corps",
      infoTipoMisure2: "mesures de chemise",
      infoTipoMisure3: "J'enverrai une chemise pour la mesurer",
      infoTagliaSelezionata: "taille sélectionnée:",
      infoVestibilita: "Coupe",
      aggiungiIniziali: "Ajouter des initiales",
      stile1: "style",
      colore1: "coleur",
      posizione1: "emplacement",
    },
  },
  barraAcquisto: {
    lang: "fr",
    nonDisponibile: "Tissu non disponible.",
    tooltip: "Ajouter cette chemise au panier",
    carrello: "Ajouter au panier",
    camicia: "Chemise ",
    tessuto: "Tissu",
    di: " de",
    aggiunta: "La chemise a été ajoutée au panier",
    aggiunta1: "La chemise a été ajouté au panier.",
    aggiunta2: "Que veux-tu faire maintenant?",
    continua: "Continuer les achats",
    vai: "Aller au panier",
    wishlist: {
      lang: "fr",
      nuovoPrezzo: "Nouveau prix",
      nonDisponibile: "Attention, tissu non disponible!",
      wishlist: "Liste de souhaits",
      vuota: "Votre liste de souhaits est vide.",
      Camicia: "Chemise",
      tooltip: "Ajouter la chemise à la liste de souhaits",
      successo: "Chemise ajoutèe à la liste de souhaits",
      rimossa: "Chemise retiré à la liste de souhaits",
      Prodotto: "Produit",
      Prezzo: "Prix",
      Descrizione: "Description",
      Tessuto: "Tissu",
      Disegno: "Motif",
      Colletto: "Cou",
      Italiano: "Italien",
      "Italiano Classico": "Italien Classique",
      "Francese Classico": "Francais",
      "Francese Semiaperto": "Semi Francais",
      "Francese Semiaperto due bottoni": "Semi Francais deux boutons",
      "Button Down Classico": "Amèricain Button Down",
      "Button Down Alto dos botons": "Amèricain Button Down haute deux boutons",
      Diplomatico: "Cassè",
      Coreano: "Corèenne",
      "Polsino Arrotondato": "Poignet Ronde",
      "Polsino Smussato": "Poignet Carre",
      "Polsino Gemelli": "Poignet Manchette",
      "Manica Corta": "Manche Courte",
      Chiusura: "Fermeture",
      "Faldoncino Interno non Impunturato": "Simple",
      "Faldoncino Esterno Impunturato": "Americaine",
      "Finta Doppia e bottoni nascosti": "Cachè",
      "Nessun Taschino": "Sans Poches",
      "Taschino arrotandato": "Poche arrondie",
      "Taschino Smussato": "Poche carre",
      "Due Taschini Arrotondati": "Deux Poches arrondie",
      "Due Taschini Smussati": "Deux Poches carre",
      "Dietro Liscio": "Sans pinces",
      "Dietro con Doppie Pinces": "Double pinces",
      "Dietro con Doppia Piega": "Pinces au centre",
      "Asola Bianca": "Boutonnière blanc",
      "Asola Blu": "Boutonnière bleu",
      "Asola Celeste": "Boutonnière bleu clair",
      "Asola Grigia": "Boutonnière gris",
      "Asola Nera": "Boutonnière noir",
      "Asola Rossa": "Boutonnière rouge",
      "Bottone Bianco": "Boutons blanc",
      "Bottone Blu": "Boutons bleu",
      "Bottone Celeste": "Boutons bleu clair",
      "Bottone Grigio": "Boutons gris",
      "Bottone Nero": "Boutons noir",
      "Bottone Rosso": "Boutons rouge",
      "Filo Bianco": "Fil blanc",
      "Filo Blu": "Fil bleu",
      "Filo Celeste": "Fil bleu clair",
      "Filo Grigio": "Fil gris",
      "Filo nero": "Fil noir",
      "Filo rosso": "Fil rouge",
      Contrasto: "Contraste",
      contrastoPolsino: "Poignet",
      contrastoColletto: "Cou",
      contrastoChiusura: "Fermeture",
      Stile: "Style",
      Iniziali: "Initiales",
      iniStile: "Style",
      iniColore: "Couleur",
      iniPosition: "Emplacement",
      white: "Blanc",
      slateblue: "Bleu",
      lightsteelblue: "Bleu clair",
      lightgray: "Gris",
      black: "Noir",
      crimson: "Rouge",
      posizione: "Choisir la position ",
      sopra: "Haut",
      centro: "Centre",
      sotto: "Bas",
      rimuovi: "Supprimer de la Wishlist",
      importa: "importer dans le configurateur",
      torna: "Retour au configurateur",
    },
  },
  tutorial: {
    braccia: {
      header: "Manches",
      titolo: "Manches",
      descrizione:
        "Mesurez la manche de l'épaule au poignet en maintenant votre bras plié à 90°.",
    },
    mezzaManica: {
      header: "Mezza Manica",
      titolo: "Misura della mezza manica",
      descrizione:
        "Misura la manica dalla spalla sino alla lunghezza desiderata per un minimo di 18cm e un massimo di 30cm",
    },
    bicipite: {
      header: "Biceps",
      titolo: "Mesure du biceps",
      descrizione:
        "Mesurez les biceps / triceps à cm. 16 à partir de la pointe extérieure de l'épaule.",
    },
    avambraccio: {
      header: "avambraccio",
      titolo: "Misura dell'avambraccio",
      descrizione: "Misura l'avambraccio appena sotto il gomito.",
    },
    fianco: {
      header: "Fianco",
      titolo: "Misura del Fianco",
      descrizione:
        "Misura il fianco all'altezza della fine della tasca dei pantaloni passando per l'altezza a meta' dei glutei.",
    },
    puntoVitaDietro: {
      header: "Fianco",
      titolo: "Misura del punto vita dietro",
      descrizione:
        "Misura partendo dall'attaccatura dietro del collo fino ad intercettare il punto più stretto in vita ( misure slim).",
    },
    mezzoTorace: {
      header: "mezzo torace",
      titolo: "Misura del mezzo torace",
      descrizione:
        "Misura la distanza (indossando una camicia ) tra l'attaccatura del carrè al collo scendendo verso il basso (per persone corpulente). ",
    },
    puntoTorace: {
      header: "punto torace",
      titolo: "Misura del punto torace",
      descrizione:
        "Misura dall'attaccatura del carrè al collo fino al capezzolo sul torace ( determina l'altezza del torace).",
    },
    bracciaCamicia: {
      header: "Bras",
      titolo: "Mesure du bras",
      descrizione:
        "Mesurez la manche de la couture la plus haute de l'épaule à l'extrémité du poignet, en gardant la chemise à plat sur une surface plane..",
    },
    collo: {
      header: "Cou",
      titolo: "Mesure du cou",
      descrizione:
        "Mesurez immédiatement sous la pomme d'Adam, en faisant glisser le metre ruban autour du cou pour prendre la circonférence. Il est important d’insérer un doigt entre la metre ruband et le cou pour assurer une prise confortable.",
    },
    colloCamicia: {
      header: "Cou",
      titolo: "Mesure du cou",
      descrizione:
        "Mesurez la distance entre le bouton du col et la boutonnière correspondante, en gardant le col ouvert et couché sur une surface plane.",
    },
    girovita: {
      header: "Taille",
      titolo: "Mesure de la taille",
      descrizione:
        "Mesurez la taille au point le plus large, à la hauteur du nombril, en laissant toujours un doigt de tolérance entre le corps et le ruban à mesurer pour pouvoir vous asseoir confortablement. Il est important de prendre des mesures précises tout en maintenant le ruban à mesurer bien en place sur le corps.",
    },
    girovitaCamicia: {
      header: "Taille",
      titolo: "Mesure de la taille",
      descrizione:
        "Mesurez la taille au point le plus large au niveau du nombril, entre les deuxième et troisième boutons à partir du bas, en gardant la chemise à plat sur une surface plane. Si vous avez des hanches larges, il est conseillé de prendre la mesure légèrement plus bas, pour les comprendre au total.",
    },
    polso: {
      header: "Poignet",
      titolo: "Mesure du poignet",
      descrizione:
        "Mesurez la circonférence du poignet au niveau de l'articulation.",
    },
    polsoCamicia: {
      header: "Poignet",
      titolo: "Mesure du poignet",
      descrizione:
        "Mesurez la distance linéaire entre le bouton de la manchette et la boutonnière correspondante, en gardant la manchette ouvert et à plat sur une surface plane.",
    },
    spalle: {
      header: "Epaules",
      titolo: "Mesure des épaules",
      descrizione: "Mesurer l'épaule au point le plus large.",
    },
    spalleCamicia: {
      header: "Epaules",
      titolo: "Mesure des épaules",
      descrizione: "Mesurez la largeur des épaules au point le plus large.",
    },
    torace: {
      header: "Poitrine",
      titolo: "Mesures de la poitrine",
      descrizione:
        "Mesurer le tour de poitrine à la hauteur du mamelon. Pour un bon ajustement, vous devez rejoindre le ruban à mesurer sur la poitrine en tenant toujours un doigt de tolérance entre le corps et le ruban à mesurer pour pouvoir bouger librement.",
    },
    toraceCamicia: {
      header: "Poitrine",
      titolo: "Tour de poitrine",
      descrizione:
        "Mesurez votre tour de poitrine à hauteur de poitrine. Pour un ajustement correct, il est nécessaire de faire adhérer le ruban à la poitrine, en gardant toujours la tolérance d'un doigt entre le corps et le mètre afin de pouvoir bouger librement.",
    },
    lunghezza: {
      header: "Longueur",
      titolo: "Mesure de la longueur",
      descrizione:
        "Incline la tête en avant et mesure à partir du centre de la base du cou, à l'entrejambe du pantalon .",
    },
    lunghezzaCamicia: {
      header: "Longueur",
      titolo: "Mesure de la longueur",
      descrizione:
        "En gardant la chemise à plat sur une surface plane, mesurez à partir du centre de la base arrière du cou, au centre de la couture entre la chemise et le col, jusqu'à l'ourlet inférieur.",
    },
    colloSpalla: {
      header: "Distance Cou - Epaule",
      titolo: "Collo Spalla",
      descrizione:
        "Devrait Mesurer la distance entre l'attache du cou et le bout de l'épaule. Il est important de déterminer si vous voulez une grande épaule précise 'taillée' ou casual 'large'.",
    },
    pettoGiro: {
      header: "Poitrine - Taille Ronde",
      titolo: "Poitrine - Taille Ronde",
      descrizione:
        "Mesurez l'avant entre la deuxième et la troisième Boutons jusqu'à la couture de la manche.",
    },
    pettoSpalla: {
      header: "Taille Poitrine - Epaules",
      titolo: "Taille Poitrine - Epaules",
      descrizione: "Mesure du cou à la couture de la manche avec l'épaule.",
    },
    fianco: {
      header: "Côté",
      titolo: "Côté",
      descrizione: "Mesurer la hanche au point le plus large.",
    },
    giroManica: {
      header: "Emmanchure",
      titolo: "Emmanchure",
      descrizione:
        "Mesurer les emmanchures à hauteur d'épaule en laissant un doigt entre le mètre ruban et le bras.",
    },
  },
  contatti: {
    richiesto: "Champs requis",
    emailInvalida: "Adresse email invalide",
    titolo: "Nous aimons vous parler",
    successo: "Merci. Votre message a été envoyé avec succès.",
    errore: "Attention. Une erreur est survenue.",
    nome: "Nom *",
    email: "Email *",
    oggetto: "Sujet *",
    messaggio: "Message *",
    attendere: "Attendre...",
    invia: "Envoyer",
    testo01:
      "CHAQUE COMMANDE EXIGE AU MOINS 20 JOURS OUVRABLES AVANT L’EXPÉDITION. Nous nous excusons de cette nuisance, mais votre chemise ne ressemblera pas à toutes les autres. ",
    testo02:
      "Sartoria Turrisi se trouve à Ceglie Messapica, une ville accueillante de la province de Brindisi, au sud des Pouilles.",
    testo03:
      "Depuis 1970, notre tradition vestimentaire se transmet de père en fils: nous sommes une petite entreprise artisanale qui travaille avec passion à toutes les étapes de la production, qui est réalisée exclusivement dans notre atelier de couture par des artisans Italiens hautement spécialisés.",
    testo04:
      "Le choix de tissus et d'accessoires de la plus haute qualité nous permet d'offrir l'excellence de l'authentique \"Made in Italy\".",
    testo05:
      "Notre objectif est de satisfaire notre client dans tous ses besoins, en mettant notre longue expérience à sa disposition.",
    testo06:
      "Il est aujourd'hui possible de confondre un sculpteur avec un tailleur, car tous deux créent des formes.",
    testo07: "KARL KRAUS",
    testo08:
      "Vous pouvez apprécier la qualité de nos tissus de vos propres mains.",
    testo09: "COMMANDEZ VOTRE KIT GRATUIT MAINTENANT!",
  },
  pagina404: {
    errore: "Error 404",
    nonEsiste: "La page que vous recherchez n'existe pas!",
    torna: "Retour au configurateur",
  },
};
